function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 6,
  fill: "#A094ED"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.6 11.6H10.4C9.08 11.6 8 12.68 8 14v11.6c0 1.32 1.08 2.4 2.4 2.4h19.2c1.32 0 2.4-1.08 2.4-2.4V14c0-1.32-1.08-2.4-2.4-2.4zM19.44 25.2h-6.88c-.76 0-1.36-.84-1.36-1.64.04-1.2 1.28-1.92 2.6-2.52.92-.4 1.04-.76 1.04-1.16 0-.4-.24-.76-.56-1.04-.52-.48-.84-1.2-.84-2 0-1.52.92-2.8 2.52-2.8s2.52 1.28 2.52 2.8c0 .8-.28 1.52-.84 2-.32.28-.56.64-.56 1.04s.12.76 1.04 1.12c1.32.56 2.56 1.36 2.6 2.56.08.8-.52 1.64-1.28 1.64zm9.36-2.8c0 .44-.36.8-.8.8h-3.6c-.44 0-.8-.36-.8-.8v-1.2c0-.44.36-.8.8-.8H28c.44 0 .8.36.8.8v1.2zm0-4.4c0 .44-.36.8-.8.8h-6c-.44 0-.8-.36-.8-.8v-1.2c0-.44.36-.8.8-.8h6c.44 0 .8.36.8.8V18z",
  fill: "#fff"
});

var SvgSfContact = function SvgSfContact(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgSfContact;